import { Injectable } from '@angular/core';
import { Observable, forkJoin, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ApiService } from './api.service';
import { environment } from '../../environments/environment';

const QA_MAGASIN = { id: 999, nom: 'Magasin Test QA', adresse: 'Adresse test QA', actif: 0 };

@Injectable({
  providedIn: 'root'
})
export class MagasinService {
  constructor(private api: ApiService) {}

  getMagasinsActifs(): Observable<any[]> {
    return this.api.get<any[]>('/magasins/actifs');
  }

  getMagasinsActifsAvecQA(): Observable<any[]> {
    if (environment.production) {
      return this.getMagasinsActifs();
    }

    return forkJoin([
      this.getMagasinsActifs(),
      this.api.get<any>('/labase/qa/magasin').pipe(catchError(() => of(null)))
    ]).pipe(
      map(([magasins, qaResponse]) => {
        const qaMagasin = qaResponse?.magasin || QA_MAGASIN;
        if (!magasins.some((m: any) => m.id === qaMagasin.id)) {
          return [...magasins, qaMagasin];
        }
        return magasins;
      })
    );
  }
}
